import { shape, string } from "prop-types"

export const ProjectShape = shape({
    projectId: string.isRequired,
    name: string.isRequired,
    code: string
})